import { Component, Input } from "@angular/core";
import { ActivityTypeInfo } from "../../services/activity.service";

@Component({
    selector: "activity-types-legend",
    template: require('./activity-types-legend.component.html'),
    styles: [require('./activity-types-legend.component.css')]
})
export class ActivityTypesLegendComponent {
    @Input()
    activityTypes: ActivityTypeInfo[];

    @Input()
    inlineHeader: boolean;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/shared/activity-types-legend.component.ts